<template>
  <div class="dimension-input" :class="!metric && 'imperial'">
    <template v-if="!metric">
      <unit-input v-model="feet" placeholder="Feet" mark="'" />
      <template v-if="showInches">
        <unit-input v-model="inches" placeholder="Inches" mark='"' />
      </template>
      <template v-if="!showInches">
        <span class="input-right-border"></span>
      </template>
    </template>
    <template v-else-if="metric">
      <unit-input v-model="centimeters" placeholder="Cm" mark='cm' />
    </template>
  </div>
</template>

<script>
import UnitInput from './UnitInput'
import * as lodash from 'lodash'

export default {
  components: {
    UnitInput
  },
  data() {
    return {
      centimeters: Math.round(this.value * 2.54) // convert to cm
    }
  },
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100 * 12
    },
    showInches: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    metric() {
      return this.$store.getters.metric
    },
    design() {
      return this.$store.getters.design
    },
    feet: {
      get() {
        return this.value / 12 | 0
      },
      set(v) {
        this.outputImperial(v * 12 + this.inches)
      }
    },
    inches: {
      get() {
        return this.value % 12
      },
      set(v) {
        this.outputImperial(this.feet * 12 + v)
      }
    },
  },
  watch: {
    centimeters(newValue) {
      this.outputMetric(newValue)
    }
  },
  methods: {
    outputImperial(v) {
      if (isNaN(v)) v = 0
      if (v < this.min) v = this.min
      if (v > this.max) v = this.max
      this.$emit('input', Number(v))
    },
    outputMetric(v) {
      if (isNaN(v)) v = 0
      if (v < this.min) v = this.min
      this.$emit('input', Number(this.centimeters))
    },
  }
}
</script>

<style lang="postcss" scoped>
.dimension-input {
  display: flex;
  width: 100%;

  &>* {
    flex: 1 1 auto;
  }

  &.imperial>*:first-child {
    border-right: none;
  }
}

.input-right-border {
  height: 45px;
  border-right: solid 2px #aeaeae;
}
</style>



// WEBPACK FOOTER //
// DimensionInput.vue?589aabba